import { render, staticRenderFns } from "./wikiUnitSearch.vue?vue&type=template&id=4ec7ec4b&scoped=true&"
import script from "./wikiUnitSearch.vue?vue&type=script&lang=js&"
export * from "./wikiUnitSearch.vue?vue&type=script&lang=js&"
import style0 from "./wikiUnitSearch.vue?vue&type=style&index=0&id=4ec7ec4b&prod&lang=scss&scoped=true&"
import style1 from "./wikiUnitSearch.vue?vue&type=style&index=1&id=4ec7ec4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec7ec4b",
  null
  
)

export default component.exports